<template>
  <el-popover
    v-model="dropDownDisplay"
    class="table-custom-header"
    :width="150"
    placement="bottom"
    trigger="click"
    :visible-arrow="false"
  >
    <!-- 搜索框 -->
    <Search
      v-if="search && dropDownDisplay"
      :default-value="defaultTitleValue"
      @handleSearch="handleSearch"
    ></Search>
    <!-- 类型选择 -->
    <CheckboxGroup
      :options="typeList"
      @handleCheckedChange="handleCheckedChange"
      v-if="typeSelector"
    ></CheckboxGroup>
    <!-- <div v-if="typeSelector" class="type-selector-container">
      <el-checkbox
        :indeterminate="checkGroup.isIndeterminate"
        v-model="checkGroup.checkAll"
        @change="handleCheckAllChange"
        >全选</el-checkbox
      >
      <div style="margin: 15px 0"></div>
      <el-checkbox-group v-model="checkGroup.checkedTypes" @change="handleCheckedChange">
        <el-checkbox v-for="type in typeList" :label="type" :key="type">{{ type }}</el-checkbox>
      </el-checkbox-group>
    </div> -->
    <!-- 日期选择器 -->
    <div class="date-selector-container">
      <!-- <el-date-picker
        class="date-selector"
        v-if="dateSelector"
        v-model="dateRange"
        @change="handleDateChange"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker> -->
      <Search
        v-if="dateSelector && dropDownDisplay"
        :default-value="defaultDateValue"
        @handleSearch="handleDateChange"
      ></Search>
    </div>
    <span slot="reference" style="cursor: pointer">{{ title }}</span>
  </el-popover>
</template>

<script>
import Search from "../../Tables/Search"
import CheckboxGroup from "../../CheckboxGroup"
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    search: {
      type: Boolean,
      default: false,
    },
    dateSelector: {
      type: Boolean,
      default: false,
    },
    typeSelector: {
      type: Boolean,
      default: false,
    },
    typeList: {
      type: Array,
      default: () => [],
    },
    //名称搜索框数据
    filterData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Search,
    CheckboxGroup,
  },
  watch: {
    filterData: {
      handler(newVal) {
        if (newVal) {
          this.defaultTitleValue = newVal.title
          this.defaultDateValue = newVal.date
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      dropDownDisplay: false,
      defaultTitleValue: "",
      defaultDateValue: "",
      // selectedDate: "",
      // checkGroup: {
      //   isIndeterminate: false,
      //   checkAll: true,
      //   checkedTypes: [...this.typeList],
      //   checkedType: "",
      // },
    }
  },
  methods: {
    handleSearch(value) {
      this.$emit("handleTitleSearch", value)
    },
    handleDateChange(value) {
      // this.$emit("handleDateSearch", this.dateRange)
      this.$emit("handleDateSearch", value)
    },
    // handleCheckAllChange(val) {
    //   this.checkGroup.checkedTypes = val ? this.typeList : []
    //   this.checkGroup.isIndeterminate = false
    //   this.$emit("handleTypeSelect", this.checkGroup.checkedTypes)
    // },
    // handleCheckedChange(value) {
    //   let checkedCount = value.length
    //   this.checkGroup.checkAll = checkedCount === this.typeList.length
    //   this.checkGroup.isIndeterminate = checkedCount > 0 && checkedCount < this.typeList.length
    //   this.$emit("handleTypeSelect", this.checkGroup.checkedTypes)
    // },
    handleCheckedChange(checkedTypes) {
      this.$emit("handleTypeSelect", checkedTypes)
    },
  },
}
</script>

<style lang="scss">
.table-custom-header {
  .el-checkbox-group {
    display: flex;
    flex-direction: column;
  }
}
</style>
